import { ReactNode, createContext } from 'react'
import { useBanks } from '../hooks/useBanks'
import { banksResponse } from '../services/transactionService/banks'

interface BanksContextValue {
  isLoading: boolean
  isFetching: boolean
  data: banksResponse | undefined
}

export const BanksContext = createContext({} as BanksContextValue)

export const BanksProvider = ({ children }: { children: ReactNode }) => {
  const { data, isFetching, isLoading } = useBanks({ allBanks: false })

  return (
    <BanksContext.Provider
      value={{
        data,
        isFetching,
        isLoading,
      }}
    >
      {children}
    </BanksContext.Provider>
  )
}
